import { FC } from "react";

import { IconProps, InfoOutlineIcon } from "@chakra-ui/icons";

const CustomIcon: FC<Omit<IconProps, "css">> = ({ children, ...props }) => (
  <InfoOutlineIcon width="22" height="22" fill="none" color="#015DEA" {...props} />
);

export default CustomIcon;
